import { useTexts } from '../../useTexts'

import { form } from '../../formState'

export function TrackingLink() {
  const texts = useTexts()

  return (
    <form.Checkbox
      helperText={texts.trackingLinkHelperText}
      name="includeMessageTrackingLink"
      testId="includeMessageTrackingLink"
      label={texts.trackingLinkLabel}
      validateOn="focus blur"
    />
  )
}
